import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Trigger} from '~local/app/types/Trigger';
import {Observable} from 'rxjs';
import {DataSourceResponse, DataSourceService} from './DataSourceService';

@Injectable()
export class TriggersService extends DataSourceService<Trigger> {
    constructor(private http: HttpClient) {
        super();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10
    ): Observable<DataSourceResponse<Trigger>> {
        return this.http.get<DataSourceResponse<Trigger>>('/admin/settings/trigger/list', {
            params: new HttpParams()
                .set('filter', filter)
                .set('orderBy', orderBy)
                .set('sort', orderDirection.toUpperCase())
                .set('skip', pageNumber.toString())
                .set('take', pageSize.toString())
        });
    }
}
